import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText, Scale, AlertCircle } from 'lucide-react';

export default function TermsPage() {
  return (
    <div className="@container/terms max-w-[1800px] w-full mx-auto px-3 py-4 @[740px]/terms:px-4 @[740px]/terms:py-5 @[1100px]/terms:px-6 @[1100px]/terms:py-6 space-y-4 @[740px]/terms:space-y-5 @[1100px]/terms:space-y-6">
      <div className="space-y-3 @[740px]/terms:space-y-4">
        <h1 className="text-xl @[740px]/terms:text-2xl @[1100px]/terms:text-3xl font-bold">Terms of Service</h1>
        <p className="text-muted-foreground text-lg">
          Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>
      </div>

      <Card>
        <CardHeader>
          <FileText className="h-8 w-8 text-primary mb-2" />
          <CardTitle>Agreement to Terms</CardTitle>
          <CardDescription>
            By using our platform, you agree to these terms
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <section>
            <h2 className="text-xl font-semibold mb-3">Acceptance of Terms</h2>
            <p className="text-sm text-muted-foreground">
              By accessing and using the Dominion Mandate platform, you accept and agree 
              to be bound by these Terms of Service. If you do not agree to these terms, 
              please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Use of Service</h2>
            <div className="space-y-2">
              <p className="text-sm text-muted-foreground mb-2">You agree to:</p>
              <ul className="text-sm text-muted-foreground space-y-1 list-disc list-inside ml-4">
                <li>Use the platform only for lawful purposes</li>
                <li>Maintain the security of your account credentials</li>
                <li>Not share your account with others</li>
                <li>Respect the rights of other users</li>
                <li>Not engage in any activity that disrupts or harms the platform</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Account Responsibilities</h2>
            <div className="flex items-start gap-3">
              <Scale className="h-5 w-5 text-primary mt-0.5" />
              <div>
                <p className="text-sm text-muted-foreground">
                  You are responsible for maintaining the confidentiality of your account 
                  and password. You agree to accept responsibility for all activities that 
                  occur under your account.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Content and Intellectual Property</h2>
            <p className="text-sm text-muted-foreground">
              All content on the Dominion Mandate platform, including but not limited to 
              text, graphics, logos, images, and software, is the property of Dominion Mandate or
              its content suppliers and is protected by copyright and other intellectual property laws.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Prohibited Activities</h2>
            <div className="flex items-start gap-3">
              <AlertCircle className="h-5 w-5 text-primary mt-0.5" />
              <div>
                <p className="text-sm text-muted-foreground mb-2">You may not:</p>
                <ul className="text-sm text-muted-foreground space-y-1 list-disc list-inside ml-4">
                  <li>Attempt to gain unauthorized access to the platform</li>
                  <li>Interfere with or disrupt the platform's operation</li>
                  <li>Copy, modify, or distribute content without permission</li>
                  <li>Use the platform for any illegal or unauthorized purpose</li>
                </ul>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Limitation of Liability</h2>
            <p className="text-sm text-muted-foreground">
              Dominion Mandate shall not be liable for any indirect, incidental, special, 
              consequential, or punitive damages resulting from your use of or inability to use 
              the platform.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Changes to Terms</h2>
            <p className="text-sm text-muted-foreground">
              We reserve the right to modify these terms at any time. We will notify users of 
              any material changes. Your continued use of the platform after changes constitutes 
              acceptance of the new terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Contact Information</h2>
            <p className="text-sm text-muted-foreground">
              If you have questions about these Terms of Service, please contact us at{' '}
              <a href="mailto:streaming@dominioncity.org.za" className="text-primary hover:underline">
                streaming@dominioncity.org.za
              </a>
            </p>
          </section>
        </CardContent>
      </Card>
    </div>
  );
}
